import apiFetch from '../apiFetch'

export default function (token, id) {
  return apiFetch({ endPoint: `FinancingTypeProduct/Active/${id}`, method: 'POST', body: null, token: token })
}
